import { Actions, ActionTypes } from '@appStore/account/actions';
import { AccessRequest } from "@model";

export interface State {
    accessRequests: AccessRequest[];
    loading: boolean;
    loaded: boolean;
    removing: boolean;
    removed: boolean;
}

export const initialState: State = {
    accessRequests: [],
    loading: false,
    loaded: false,
    removing: false,
    removed: false
};

export function reducer(state = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypes.MyAccessRequestsLoad:
            return { ...state, loaded: false, loading: true };
        case ActionTypes.MyAccessRequestsLoadSuccess:
            return { ...state, loaded: true, loading: false, accessRequests: action.payload };
        case ActionTypes.MyAccessRequestsLoadFail:
            return { ...state, loaded: true, loading: false };
        case ActionTypes.MyAccessRequestsRemove:
            return { ...state, removing: true, removed: false };
        case ActionTypes.MyAccessRequestsRemoveSuccess:
            return {
                ...state,
                removing: false,
                removed: true,
                accessRequests: state.accessRequests.filter(ar => ar.id !== action.payload)
            };
        case ActionTypes.MyAccessRequestsRemoveFail:
            return { ...state, removing: false, removed: false };
    }

    return state;
}

export const getMyAccessRequests = (state: State) => state.accessRequests;
export const getMyAccessRequestsLoaded = (state: State) => state.loaded; 
export const getMyAccessRequestsLoading = (state: State) => state.loading;

export const getMyAccessRequestsRemoving = (state: State) => state.removing;
export const getMyAccessRequestsRemoved = (state: State) => state.removed;
